<template>
    <section>
        <van-popup v-model="show" theme="round" round >
            <section class="popup-box">
                <section class="title-wrap">
                    <span class="title" v-if="showTitle">{{ title }}</span>
                    <van-icon class="icon" name="cross" size="15" @click="show = false" />
                </section>
                <section class="content"><slot/></section>
                <section :class="['footer', {'one': !showCancel }]">
                    <template v-if="showCancel">
                        <section class="button cancal" @click="cancal">{{ cancelText }}</section>
                        <section class="button confirm" @click="confirm">{{ confirmText }}</section>
                    </template>
                    <template v-else>
                        <section class="button" @click="confirm">{{ confirmText }}</section>
                    </template>
                </section>
            </section>
        </van-popup>
    </section>
</template>

<script>
export default {
    name: 'CouponDialog',
    props: {
        title: [String],
        cancelText: {
            type: [String],
            default: '取消'
        },
        confirmText: {
            type: [String],
            default: '确定'
        },
        showCancel: {
            type: [Boolean],
            default: true
        },
        showTitle: {
            type: [Boolean],
            default: true
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        close() {
            this.show = false
        },
        open() {
            this.show = true
        },
        cancal() {
            this.$emit('cancal',{})
        },
        confirm() {
            this.$emit('confirm',{})
        }
    }
}
</script>

<style lang="scss" scoped>
.popup-box {
    border-radius: 16px;
    width: 640px;
    min-height: 616px;
    background: #FFFFFF;

    .title-wrap {
        display: flex;
        justify-content: center;
        position: relative;
        width: 100%;
        height: 112px;
        font-size: 32px;
        .title {
            border-bottom: 1px solid #EEE;
            width: 100%;
            height: 112px;
            font-weight: bold;
            text-align: center;
            line-height: 112px;
        }

        .icon {
            position: absolute;
            right: 10px;
            top: 32px;
            border: 1px solid #333;
            border-radius: 50%;
            width: 48px;
            height: 48px;
            line-height: 48px;
            text-align: center;
        }
    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &.one {
            padding: 32px 0;
            justify-content: center;
            .button {
                border-radius: 44px;
                width: 544px;
                height: 88px;
                font-size: 32px;
                line-height: 88px;
                text-align: center;
                color: #FFF;
                background: #00C5A5;
            }
        }
        .cancal,.confirm {
            border-top: 1px solid #EEE;
            width: 50%;
            font-size: 32px;
            font-weight: bold;
            line-height: 112px;
            text-align: center;
        }
        .cancal {
            color: #999;
        }
        .confirm {
            box-sizing: border-box;
            border-left: 1px solid #EEE;
            color: turquoise;
        }
    }
}
</style>